import React, {FC} from 'react'
import {useSelector} from 'react-redux'
import {select_speedBump} from 'redux/speedBump/selectors'
import {useAppDispatch} from 'redux/config'
import {speedBumpAC} from 'redux/speedBump/speedBump.duck'
import {Hint, Modal, Button} from '@mdsol/onex-design'

import './speedBump.scss'

const SpeedBump: FC = () => {
  const dispatch = useAppDispatch()

  const {show, variant, title, body} = useSelector(select_speedBump)

  const handleConfirm = () => {
    dispatch(speedBumpAC.confirmSpeedBump())
  }

  const handleCancel = () => {
    dispatch(speedBumpAC.cancelSpeedBump())
  }

  return (
    <Modal
      dataTestId='speedBump-modal'
      show={show}
      backdrop='static'
      handleClose={handleCancel}
      size='sm'
      title={title}
      id='app-modal'
    >
      <Modal.Body>
        <Hint dataTestId='hint-speed-bump' variant={variant}>
          {body}
        </Hint>
      </Modal.Body>
      <Modal.Footer>
        <Button dataTestId='modal-confirm-button' size='md' onClick={handleConfirm} className={`btn-${variant}`}>
          OK
        </Button>
        <Button dataTestId='modal-cancel-button' size='md' onClick={handleCancel} variant='secondary'>
          Cancel
        </Button>
      </Modal.Footer>
    </Modal>
  )
}

export default SpeedBump
